// MK: shared "add to cart" plumbing used by both direct-add buttons (single-variant
// products) and the variant-picker modal (mk-variant-modal.js, multi-variant products).
// Posts to Shopify's Ajax Cart API, updates the header cart bubble if present, and
// shows a small toast. Does not touch the cart drawer (out of scope).
window.MK = window.MK || {};

(function () {
  function updateCartBubble(count) {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    var bubble = cartIcon.querySelector('.cart-count-bubble');
    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      cartIcon.appendChild(bubble);
    }
    bubble.innerHTML =
      (count < 100 ? '<span aria-hidden="true">' + count + '</span>' : '') +
      '<span class="visually-hidden">' + count + ' items in cart</span>';
  }

  function showToast(message) {
    var toast = document.querySelector('.mk-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mk-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('mk-toast--visible');
    clearTimeout(toast._mkTimer);
    toast._mkTimer = setTimeout(function () {
      toast.classList.remove('mk-toast--visible');
    }, 2600);
  }

  // Shared add-to-cart call. Returns a Promise. `onSettle` (optional) always fires,
  // useful for resetting a button's disabled/label state regardless of outcome.
  // `quantity` may be omitted (defaults to 1) or passed as the 2nd arg with
  // `onSettle` shifted to 3rd — kept backwards-compatible with existing callers.
  // `sellingPlanId` (optional 4th arg) adds a real Shopify selling plan (subscription)
  // to the line item instead of a one-time purchase.
  //
  // Requests the cart-drawer/cart-icon-bubble section HTML in the same request and
  // hands it to the native <cart-drawer> component's own renderContents(), same as
  // Dawn/Iris's stock product-form does. Without this, our own fetch() add bypasses
  // the drawer entirely — it never learns anything changed, so it keeps showing
  // whatever it last rendered (typically "Your cart is empty" from page load) until
  // a full page reload forces it to re-render from scratch.
  function addToCart(variantId, quantity, onSettle, sellingPlanId) {
    if (typeof quantity === 'function') { onSettle = quantity; quantity = 1; }
    quantity = quantity || 1;
    var item = { id: variantId, quantity: quantity };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = cartDrawer ? ['cart-drawer', 'cart-icon-bubble'] : ['cart-icon-bubble'];
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item], sections: sections, sections_url: window.location.pathname })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (result) {
        var addedItem = result.items ? result.items[0] : result;
        if (cartDrawer && result.sections && result.sections['cart-drawer']) {
          cartDrawer.renderContents(result);
        } else if (result.sections && result.sections['cart-icon-bubble']) {
          var bubbleHtml = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
          var freshBubble = bubbleHtml.querySelector('.cart-count-bubble');
          var liveIcon = document.getElementById('cart-icon-bubble');
          var liveBubble = liveIcon ? liveIcon.querySelector('.cart-count-bubble') : null;
          if (liveIcon && freshBubble) {
            if (liveBubble) liveBubble.replaceWith(freshBubble); else liveIcon.appendChild(freshBubble);
          } else if (liveBubble) {
            liveBubble.remove();
          }
        }
        showToast('Added — ' + addedItem.product_title);
        return addedItem;
      })
      .catch(function (err) {
        showToast('Could not add to bag — please try again.');
        throw err;
      })
      .finally(function () {
        if (onSettle) onSettle();
      });
  }

  window.MK.addToCart = addToCart;
  window.MK.showToast = showToast;
  window.MK.updateCartBubble = updateCartBubble;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-mk-add-to-cart]');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    // Multi-variant cards hand off to the size-picker modal instead of adding directly.
    if (btn.getAttribute('data-has-variants') === 'true') {
      if (window.MK.openVariantModal) window.MK.openVariantModal(btn);
      return;
    }

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    addToCart(variantId, function () {
      btn.disabled = false;
      btn.textContent = originalText;
    });
  });
})();
